<template>
    <div>
        <nav aria-label="Pagination">
            <ul class="pagination justify-content-center b-pagination" aria-label="Pagination" aria-disabled="false">
                <li v-if="paginationData.prevUrl" class="page-item page-item--previous" :aria-label="$t('slides.previous')">
                    <nuxt-link
                        :to="`${paginationData.prevUrl}#product-list`"
                        class="page-link ico-pagination-left"
                        :title="$t('slides.previous')"
                    />
                </li>
                <li
                    v-for="(page, item) in paginationData.pages"
                    :key="item"
                    :class="{ 'page-item': true, active: page.isCurrent, 'px-0': page.url === null }"
                    data-cy="page-item"
                >
                    <span v-if="page.url === null" class="page-item__dot">…</span>

                    <nuxt-link v-else :to="`${page.url}#product-list`" class="page-link">
                        {{ page.num }}
                    </nuxt-link>
                </li>
                <li v-if="paginationData.nextUrl" class="page-item page-item--next" :aria-label="$t('slides.next')">
                    <nuxt-link
                        :to="`${paginationData.nextUrl}#product-list`"
                        class="page-link ico-pagination-right"
                        :title="$t('slides.next')"
                        data-cy="next-page"
                    />
                </li>
            </ul>
        </nav>
    </div>
</template>
<script lang="ts">
export default {
    props: {
        paginationData: {
            type: Object,
            default: null,
        },
    },

    computed: {
        currentPage(): number {
            for (const page of this.paginationData.pages) {
                if (page.isCurrent) {
                    return page.num
                }
            }

            return 1
        },
    },

    methods: {
        pushViewItemListEvents(pageNumber: number): void {
            useNuxtApp().$bus.$emit('pushViewItemListEvents', pageNumber)
        },
    },
}
</script>

<style lang="scss" scoped>
.page-item {
    &--next,
    &--previous {
        .page-link {
            &:focus,
            &:active {
                background-color: transparent;
                color: $color-dark;
            }
        }
    }
}

.pagination:deep(.page-item) .page-link {
    width: 40px;
    height: 40px;
    margin: 0 2px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-dark;
}

.ico-pagination-right,
.ico-pagination-left {
    background-image: url('/nuxt-assets/images/icons/arrow-menu.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 8px 14px;
    margin: 0;
    border: 1px solid $color-secondary-dark-green-1;
}

.ico-pagination-right {
    margin-right: -4px;
}

.ico-pagination-left {
    transform: rotate(180deg);
    margin-left: -4px;
}

.page-item__dot {
    width: 30px;
    height: 40px;
    margin: 0 2px;
    display: inline-block;
    line-height: 40px;
    text-align: center;
}

.page-item.active:deep(.page-link) {
    color: $color-white;
}
</style>
